export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-768w.bf830fc1.png";